/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamIdVerificationState } from './oralExamIdVerificationState';

export type OralExamRunStateResponseIdVerification = OralExamIdVerificationState | null;
